import React from 'react';
import { Banner } from '@v2/shared/lib/types';
import Button from '@v2/shared/components/Button';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  banner: Banner;
};

export default function SpecialDeal({ banner }: Props) {
  return (
    <div
      className="rounded-lg lg:rounded-xl p-5 lg:p-8"
      style={banner.bg_color ? { backgroundColor: banner.bg_color } : {}}
    >
      <div className="grid grid-cols-12 gap-4">
        <div className="relative col-span-5 lg:col-span-6">
          <img src={banner.image.url} width={banner.image.width} height={banner.image.height} alt={banner.name} />
        </div>
        <div className="col-span-7 lg:col-span-6">
          <h2 className="font-semibold text-xl">{banner.name}</h2>
          <p className="mb-6 font-medium text-gray-700">{banner.custom_html}</p>
          <Button
            color="secondary"
            onClick={() => {
              window.location.href = banner.url;
            }}
            size="xs"
            iconAfter={faArrowRight}
          >
            Shop Now
          </Button>
        </div>
      </div>
    </div>
  );
}
